import React, { ReactElement } from 'react'

import { useTranslation } from '@lib/i18n'

const PaymentInformation = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <>
      <h3>{t('checkout.paymentInformation.title')}</h3>
      <p>{t('checkout.paymentInformation.description')}</p>
    </>
  )
}

export default PaymentInformation
